import pluralize from 'pluralize'
import React, { useState } from 'react'
import { useSnackbar } from 'notistack'

import { notifOps, usePet } from '../../modules'

import Modal from "../reusable/modal"
import Confirm from '../reusable/confirm'

const InitiateReturn = ({ toggle, visible, id, index, record, onPerform }) => {
    const [quantity, setQuantity] = useState(record.qtyIssued)

    const { enqueueSnackbar } = useSnackbar()

    const onComplete = ({}, notif, ops) => {
        onPerform()
        notif('Return process has been initiated', ops('success'))
        
        setTimeout(toggle, 300)
    }

    const [{ loading }, execute] = usePet('initiateReturn', {
        id,
        index,
        quantity
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Initiating return...' } })

    const initiate = () => {
        if (checkQty()) 
            Confirm({
            title: 'Initiate Return Request',
            message: 'Are you sure you want to initiate a return request?',
            onOk: execute,
            okText: 'Initiate'
        })
    }

    const checkQty = () => {
        let ok = true
        if (quantity > record.qtyIssued) {
            enqueueSnackbar('You cannot return more than what is issued', notifOps('warning'))
            ok = false
        } else if (quantity < 0) {
            enqueueSnackbar('You cannot return a negative amount', notifOps('warning'))
            ok = false
        }

        return ok
    }

    return (
        <Modal
            w={ 400 }
            title="Intiate Return Request"
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap mt-3 mb-6">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        How many { pluralize(record?.item?.issuedIn) }?
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-contains"
                        type="number"
                        name="contains"
                        value={ quantity }
                        onBlur={ checkQty }
                        onChange={ e => setQuantity(e.target.value) }
                        placeholder="100" />
                </div>
            </div>
            <div className="flex justify-end">
                <button disabled={ loading } onClick={ initiate } className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Return { quantity ?? 0 } { record?.item?.issuedIn }</button>
            </div>
        </Modal>
    )
}

export default InitiateReturn